
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/coupons/[coupon_id]",
      function () {
        return require("private-next-pages/[publicId]/coupons/[coupon_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/coupons/[coupon_id]"])
      });
    }
  